import { useQuery } from "@tanstack/react-query";
import { getServiceSettings } from "../../api/apiServiceSettings";

export function useGetServiceSettings() {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["service-settings"],
        queryFn: getServiceSettings,
        retry: false,
    });

    const settingsData = data?.data || null;

    return { isLoading, error, settingsData, refetch };
}
